"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");

function installApplicationInsights(options) {
  if (process.env.NODE_ENV === "development") {
    console.warn("Application insights has been disabled for local development environments");
    return;
  }

  if (!options.instrumentationKey) {
    console.warn("Application insights has not started because no instrumentationKey was provided");
    return;
  }

  var appInsights = new applicationinsights_web_1.ApplicationInsights({
    config: {
      instrumentationKey: options.instrumentationKey,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      correlationHeaderDomains: ["*.wisr.tech", "*.wisr.com.au"],
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true
    }
  });
  appInsights.loadAppInsights(); // Manually track the initial page view, to establish the current user/session/pageview
  // Subsequent navigation should be detected by `enableAutoRouteTracking: true`

  appInsights.trackPageView();
  var nativeConsole = console; // Allowing global assign over console to implement our custom logger which publishes to app insights
  // eslint-disable-next-line no-global-assign

  console = buildConsole(nativeConsole, appInsights);
  return function () {
    console = nativeConsole;
  };
}

exports.installApplicationInsights = installApplicationInsights;

function buildConsole(native, appi) {
  return Object.assign(Object.assign({}, native), {
    debug: getLogger(native, "debug", appi, applicationinsights_web_1.SeverityLevel.Verbose),
    info: getLogger(native, "log", appi, applicationinsights_web_1.SeverityLevel.Information),
    log: getLogger(native, "log", appi, applicationinsights_web_1.SeverityLevel.Information),
    warn: getLogger(native, "warn", appi, applicationinsights_web_1.SeverityLevel.Warning),
    error: getLogger(native, "error", appi, applicationinsights_web_1.SeverityLevel.Error)
  });
}

function getLogger(nativeConsole, nativeLevel, appInsights, level) {
  function logger(originalMessage) {
    for (var _len = arguments.length, optionalParameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      optionalParameters[_key - 1] = arguments[_key];
    }

    appInsights.trackTrace({
      message: replaceParams(originalMessage, optionalParameters),
      severityLevel: level
    });
    nativeConsole[nativeLevel].apply(nativeConsole, [originalMessage].concat(optionalParameters));
  }

  return logger;
}

function replaceParams(message, params) {
  if (params.length === 0) {
    return message;
  }

  var stringParam = stringifyValue(params[0]);
  var remainingParams = params.slice(1);
  var loggerTemplateVariableMatcher = /(^.*?)%([oOdisf])(.*?$)/g;
  var match = loggerTemplateVariableMatcher.exec(message);
  var mergedMessage = match ? match[1] + stringParam + match[3] : "".concat(message, " ").concat(stringParam);
  return replaceParams(mergedMessage, remainingParams);
}

function stringifyValue(value) {
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch (e) {}
  }

  return "".concat(value);
}